module.exports = __webpack_public_path__ + "img/Truce_Logo_Indigo_Stripe.88183aad.png";